/* ============================================================
   dn42-product-card.js
   DeskNeko 4.2 (Claude) — product CARD image gallery.

   Drives the [data-dn42-card] media component from
   snippets/product-item-img.liquid:
     - dot clicks and touch swipe move between the product's images
       (the track slides, as before);
     - the first dot is active on load;
     - MOBILE: the 2nd image is revealed ONLY on tap-and-hold, and
       plain vertical scrolling never changes the image;
     - DESKTOP (fine pointer): hovering the card reveals the 2nd image.
     - Merchant 2026-07-15: the hover / tap-and-hold reveal is a
       CROSSFADE (opacity only), never a slide. The 2nd slide is
       stacked over the current one with an instant inline translate
       (no transition) and fades in/out via .dn42-peek / .dn42-peek-in
       (~420ms soft ease-out in CSS — merchant follow-up 2026-07-15:
       smoother, less snappy; instant under prefers-reduced-motion).

   Fully event-delegated on `document`, so cards injected later by AJAX
   filtering / infinite scroll / related-product widgets work with no
   re-init. Initialises exactly once (guarded below).
   ============================================================ */
(function () {
  if (window.dnCardGalleryInit) return;
  window.dnCardGalleryInit = true;

  var SWIPE_LOCK = 8;      // px of travel before we lock swipe-vs-scroll
  var SWIPE_COMMIT = 0.16; // fraction of frame width needed to change slide
  var HOLD_MS = 260;       // press duration that counts as a tap-and-hold

  var reduceMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var store = new WeakMap(); // root element -> gallery state

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }
  function rootOf(el) {
    return closest(el, '[data-dn42-card]');
  }
  function state(root) {
    var s = store.get(root);
    if (!s) {
      var track = root.querySelector('[data-dn42-track]');
      s = {
        track: track,
        frame: root.querySelector('[data-dn42-viewport]'),
        dots: root.querySelectorAll('[data-dn42-dot]'),
        count: track ? track.children.length : 1,
        index: 0,
        userNav: false
      };
      store.set(root, s);
    }
    return s;
  }

  function markSlides(s, visibleIndex) {
    if (!s.track) return;
    for (var i = 0; i < s.track.children.length; i++) {
      s.track.children[i].setAttribute('aria-hidden', i === visibleIndex ? 'false' : 'true');
    }
  }

  function paint(s, extraPct) {
    if (!s.track) return;
    var x = (-s.index * 100) + (extraPct || 0);
    s.track.style.transform = 'translateX(' + x + '%)';
    markSlides(s, s.index);
  }
  function showRaw(s, pct) {           // transient (peek/drag) — no index change
    if (s.track) s.track.style.transform = 'translateX(' + pct + '%)';
  }
  function markDots(s) {
    for (var i = 0; i < s.dots.length; i++) {
      var on = i === s.index;
      s.dots[i].classList.toggle('is-active', on);
      if (on) s.dots[i].setAttribute('aria-current', 'true');
      else s.dots[i].removeAttribute('aria-current');
    }
  }
  function goTo(root, i) {
    var s = state(root);
    if (s.count < 1) return;
    endPeek(s, true);               // manual nav always wins over a live peek
    s.index = Math.max(0, Math.min(s.count - 1, i));
    paint(s, 0);
    markDots(s);
  }

  /* ---- Crossfade peek (hover / tap-and-hold) -------------------
     The reveal must FADE, not slide (merchant 2026-07-15). The 2nd
     slide is overlaid on whatever slide is currently shown via an
     instant inline translate (the track never moves), then only its
     opacity animates through the .dn42-peek / .dn42-peek-in classes.
     Reduced motion: CSS kills the transition -> instant swap. */
  function peekSlide(s) {
    return (s.track && s.track.children.length > 1) ? s.track.children[1] : null;
  }
  function startPeek(s) {
    var slide = peekSlide(s);
    if (!slide || s.peeking) return;
    if (s.index === 1) return;      // 2nd image already showing — nothing to peek
    s.peeking = true;
    markSlides(s, 1);
    clearTimeout(s.peekCleanup);
    // Position the 2nd slide over the CURRENT slide, wherever the
    // track sits (index j): extra translate = (j - 1) * 100%.
    slide.style.transform = 'translateX(' + ((s.index - 1) * 100) + '%)';
    slide.classList.add('dn42-peek');
    void slide.offsetWidth;         // commit the opacity-0 start state
    slide.classList.add('dn42-peek-in');
  }
  function endPeek(s, instant) {
    if (!s) return;
    var slide = peekSlide(s);
    if (!slide) return;
    var wasPeeking = s.peeking;
    s.peeking = false;
    markSlides(s, s.index);
    if (instant || reduceMotion) {  // scrub NOW, even mid-fade-out
      clearTimeout(s.peekCleanup);
      slide.classList.remove('dn42-peek-in');
      slide.classList.remove('dn42-peek');
      slide.style.transform = '';
      return;
    }
    if (!wasPeeking) return;
    slide.classList.remove('dn42-peek-in');   // fades back out
    clearTimeout(s.peekCleanup);
    s.peekCleanup = setTimeout(function () {
      slide.classList.remove('dn42-peek');
      slide.style.transform = '';
    }, 480);                        // just past the 420ms fade
  }

  /* ---- Dot clicks --------------------------------------------- */
  document.addEventListener('click', function (e) {
    var dot = closest(e.target, '[data-dn42-dot]');
    if (!dot) return;
    var root = rootOf(dot);
    if (!root) return;
    e.preventDefault();
    var s = state(root);
    s.userNav = true;               // stop desktop hover-peek hijacking
    goTo(root, parseInt(dot.getAttribute('data-dn42-dot'), 10) || 0);
  });

  /* ---- Suppress the product link after a swipe / hold --------- */
  document.addEventListener('click', function (e) {
    var frame = closest(e.target, '[data-dn42-viewport]');
    if (!frame) return;
    var root = rootOf(frame);
    var s = root && store.get(root);
    if (s && s.suppressClick) {
      s.suppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }
  }, true); // capture: beat the anchor's own navigation

  /* ---- Touch: swipe + tap-and-hold ---------------------------- */
  var g = null; // active gesture

  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    var frame = closest(e.target, '[data-dn42-viewport]');
    if (!frame) return;
    var root = rootOf(frame);
    if (!root) return;
    var s = state(root);
    if (s.count < 2) return;        // nothing to swipe / peek
    var t = e.touches[0];
    g = {
      root: root, s: s, frame: frame,
      x0: t.clientX, y0: t.clientY,
      dir: null, moved: false, holding: false, canceled: false,
      width: frame.offsetWidth || 1
    };
    g.holdTimer = setTimeout(function () {
      if (g && !g.moved && g.dir === null) {
        g.holding = true;           // press-and-hold -> crossfade in the 2nd image
        startPeek(g.s);             // track does not move: fade, not slide
      }
    }, HOLD_MS);
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!g) return;
    var t = e.touches[0];
    var dx = t.clientX - g.x0;
    var dy = t.clientY - g.y0;

    if (!g.moved && (Math.abs(dx) > SWIPE_LOCK || Math.abs(dy) > SWIPE_LOCK)) {
      g.moved = true;
      clearTimeout(g.holdTimer);
      if (g.holding) {              // moved after a hold -> cancel the peek
        g.holding = false;
        g.canceled = true;
        endPeek(g.s, true);         // instant: the finger is scrolling now
      }
      g.dir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      if (g.dir === 'h' && g.frame) g.frame.classList.add('is-dragging');
    }

    if (g.dir === 'h' && !g.canceled) {
      e.preventDefault();           // take over the horizontal drag
      showRaw(g.s, (-g.s.index * 100) + (dx / g.width) * 100);
    }
  }, { passive: false });

  function endGesture(e) {
    if (!g) return;
    var cur = g;
    g = null;
    clearTimeout(cur.holdTimer);
    if (cur.frame) cur.frame.classList.remove('is-dragging');

    if (cur.holding) {                        // held to release -> fade the peek out
      endPeek(cur.s, false);
      cur.s.suppressClick = true;
    } else if (cur.dir === 'h' && !cur.canceled) {
      var t = (e.changedTouches && e.changedTouches[0]) || null;
      var dx = t ? t.clientX - cur.x0 : 0;
      var threshold = cur.width * SWIPE_COMMIT;
      if (dx <= -threshold) goTo(cur.root, cur.s.index + 1);
      else if (dx >= threshold) goTo(cur.root, cur.s.index - 1);
      else goTo(cur.root, cur.s.index);       // snap back
      if (Math.abs(dx) > SWIPE_LOCK) cur.s.suppressClick = true;
    }
    // plain tap (no move, no hold) -> allow the product link to open
  }
  document.addEventListener('touchend', endGesture, { passive: true });
  document.addEventListener('touchcancel', function () {
    if (!g) return;
    var cur = g;
    g = null;
    clearTimeout(cur.holdTimer);
    if (cur.frame) cur.frame.classList.remove('is-dragging');
    endPeek(cur.s, true);
    paint(cur.s, 0);
  }, { passive: true });

  /* ---- Desktop hover peek (fine pointer only; never on touch) -
     Crossfade, not slide: startPeek/endPeek animate opacity only. */
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var frame = closest(e.target, '[data-dn42-viewport]');
      if (!frame) return;
      if (e.relatedTarget && frame.contains(e.relatedTarget)) return; // still inside
      var root = rootOf(frame);
      if (!root) return;
      var s = state(root);
      if (s.count < 2 || s.userNav || reduceMotion) return;
      s.hoverPeek = true;
      startPeek(s);
    });
    document.addEventListener('mouseout', function (e) {
      var frame = closest(e.target, '[data-dn42-viewport]');
      if (!frame) return;
      if (e.relatedTarget && frame.contains(e.relatedTarget)) return; // moved within
      var root = rootOf(frame);
      if (!root) return;
      var s = state(root);
      if (s.hoverPeek) {
        s.hoverPeek = false;
        endPeek(s, false);          // fade back to the current slide
      }
    });
  }
})();
